module.exports = __webpack_public_path__ + "images/gov.9a2d6d50fc4ac71bec709b2e1119655d.jpg";